/**
 * DeleteIcon Component
 * Trash icon for delete action.
 */

import React from 'react';
import type { IconProps } from './types';
import { colors } from '../colors';

const defaultColor = colors.neutral[400];

const DeleteIcon: React.FC<IconProps> = ({
  size = 24,
  color = defaultColor,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.39 6h-2.511a3.72 3.72 0 00-1.408-2.153A4.262 4.262 0 0012.91 3h-1.62c-.933.001-1.838.3-2.56.847A3.72 3.72 0 007.32 6H4.81a.844.844 0 00-.573.22.723.723 0 00-.237.53c0 .199.085.39.237.53.152.141.358.22.573.22h.81v9.75c.001.994.428 1.947 1.188 2.65A4.225 4.225 0 009.67 21h4.86a4.225 4.225 0 002.862-1.1c.76-.703 1.187-1.656 1.188-2.65V7.5h.81c.215 0 .42-.079.573-.22a.723.723 0 00.237-.53.723.723 0 00-.237-.53.844.844 0 00-.573-.22zm-8.1-1.5h1.62c.502 0 .992.145 1.403.414.41.268.72.648.888 1.086H9c.168-.438.478-.818.888-1.086.41-.269.9-.413 1.403-.414zm5.67 12.75c0 .597-.256 1.169-.712 1.591a2.532 2.532 0 01-1.718.659H9.67a2.532 2.532 0 01-1.718-.659 2.169 2.169 0 01-.712-1.591V7.5h9.72v9.75z"
      fill={color}
    />
    <path
      d="M10.482 16.5c.215 0 .42-.079.572-.22a.723.723 0 00.238-.53v-4.5a.723.723 0 00-.238-.53.844.844 0 00-.572-.22c-.215 0-.421.08-.573.22a.723.723 0 00-.237.53v4.5c0 .2.085.39.237.53.152.141.358.22.573.22zM13.717 16.5c.215 0 .42-.079.572-.22a.723.723 0 00.238-.53v-4.5a.723.723 0 00-.237-.53.844.844 0 00-.573-.22c-.215 0-.421.08-.573.22a.723.723 0 00-.237.53v4.5c0 .2.085.39.237.53.152.141.358.22.573.22z"
      fill={color}
    />
  </svg>
);

export default DeleteIcon;
